var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 136,
    height: 142,
    viewBox: "0 0 136 142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 142,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.773,11.364c27.261,21.27,28.418,65.219,2.579,98.156S48.483,151.9,21.222,130.635s-28.4-65.219-2.579-98.156S87.513-9.9,114.773,11.364",
    transform: "translate(0 0)",
    fill: "#80b6c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.6,250.373h0a6.47,6.47,0,0,0,6.454,6.442h14.469V243.934H202.05a6.468,6.468,0,0,0-6.454,6.442m10.761,0a2.959,2.959,0,1,1-2.961-2.953,2.955,2.955,0,0,1,2.961,2.953",
    transform: "translate(-138.486 -172.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.7,202.155H94.654a4.311,4.311,0,0,0-4.3,4.294v28.625a4.311,4.311,0,0,0,4.3,4.294H137.7a4.313,4.313,0,0,0,4.3-4.294v-5.1H123.974a7.188,7.188,0,0,1-7.175-7.154V218.7a7.189,7.189,0,0,1,7.175-7.158h18.031v-5.1a4.313,4.313,0,0,0-4.3-4.294",
    transform: "translate(-63.972 -143.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.393,141.247l-13.339-4.264a3.6,3.6,0,0,0-4.513,2.316l-4.884,15.2H104.2l3.467-10.63s3.945.357,4.423-3.1l9.329,3.243s-1.673,3.936,1.2,5.366l-1.434,5.128H123.9l2.815-8.758a3.588,3.588,0,0,0-2.322-4.5",
    transform: "translate(-71.975 -96.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.528,184.724s-.836-5.269,5.439-5.269c6.517,0,5.443,5.269,5.443,5.269Z",
    transform: "translate(-85.31 -127.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.379,141.247l-13.339-4.264a3.6,3.6,0,0,0-4.513,2.316l-4.884,15.2h2.129l5.737-15.565,3.674,1.072-5.379,14.5h1.886l4.875-13.226,9.384,3.119-3.228,10.111h3.17l2.815-8.758a3.588,3.588,0,0,0-2.323-4.5",
    transform: "translate(-130.023 -96.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.6,165.946a1.853,1.853,0,1,1-1.855-1.85,1.851,1.851,0,0,1,1.855,1.85",
    transform: "translate(-169.142 -116.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.5,210.877a19,19,0,0,1-.606,25.718,2.457,2.457,0,0,0-.031,3.48c.021.022.043.043.066.064a2.772,2.772,0,0,0,3.775.013,23.515,23.515,0,0,0,.765-32.654,2.783,2.783,0,0,0-3.788-.17,2.476,2.476,0,0,0-.235,3.5l.044.049",
    transform: "translate(-218.18 -146.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.975,233.232a10.3,10.3,0,0,1,1.872,6.162,10.4,10.4,0,0,1-2.159,6.072,2.635,2.635,0,0,0,3.865,3.579,14.79,14.79,0,0,0,.451-19.23,2.649,2.649,0,0,0-3.72-.212,2.693,2.693,0,0,0-.308,3.625",
    transform: "translate(-200.406 -162.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.326,174.756a1.853,1.853,0,1,1-1.855-1.85,1.851,1.851,0,0,1,1.855,1.85",
    transform: "translate(-166.823 -122.543)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.764,187.869a27.986,27.986,0,0,1-.926,39.515,2.384,2.384,0,0,0-.139,3.375q.067.073.139.139a2.793,2.793,0,0,0,3.8.046,32.479,32.479,0,0,0,1.521-45.985q-.215-.228-.433-.452a2.8,2.8,0,0,0-3.8-.149,2.4,2.4,0,0,0-.279,3.391q.054.064.113.123",
    transform: "translate(-236.525 -130.184)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.833c3e140ec83f2df43a7d8799cc1331.svg";
export { ForwardRef as ReactComponent };